import { Filter } from '@tamagui/lucide-icons';
import { HeaderIcon } from '@unistocks/components/modal/header-icon';
import { HeaderButton } from '@unistocks/components/page/header/header-button/header-button';
import { Sheet } from '@unistocks/components/sheet/sheet';
import {
  PortfolioActions,
  selectTransactionFilter
} from '@unistocks/features/portfolios/store/portfolio.slice';
import { TransactionFilterForm } from '@unistocks/features/portfolios/transactions/components/transaction-filter-form';
import { TransactionFilter } from '@unistocks/features/portfolios/transactions/transaction-filter';
import { t } from '@unistocks/localization';
import { useAppDispatch, useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { useToggle } from '@unistocks/shared/hooks/use-toggle';
import { isDefined } from '@unistocks/shared/utils/util';
import { HasId } from '@unistocks/types/has-id';
import { useLocalSearchParams } from 'expo-router';
import { getVariableValue } from 'tamagui';

export const PortfolioTransactionFilter = () => {
  const { id } = useLocalSearchParams<HasId>();
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectTransactionFilter(id));
  const [showFilter, toggleFilter, setShowFilter] = useToggle(false);

  const padding = getVariableValue('$3', 'space');

  const badge = Object.entries(filter).filter(([key, value]) => {
    switch (key as keyof TransactionFilter) {
      case 'type':
      case 'minDate':
      case 'maxDate':
      case 'minAmount':
      case 'maxAmount':
      case 'status':
        return isDefined(value);

      default:
        return false;
    }
  }).length;

  const updateFilter = (newFilter: TransactionFilter) => {
    dispatch(PortfolioActions.setTransactionFilter({ id: id!, filter: newFilter }));
    setShowFilter(false);
  };

  return (
    <>
      <HeaderButton Icon={Filter} badge={badge} onPress={toggleFilter} />

      <Sheet
        open={showFilter}
        onOpenChange={setShowFilter}
        enableDynamicSizing
        scrollViewProps={{ contentContainerStyle: { paddingTop: padding } }}
        headerTitle={t('::Transactions:Filter')}
        headerIcon={<HeaderIcon Icon={Filter} />}
      >
        <TransactionFilterForm initialValues={filter} onSubmit={updateFilter} />
      </Sheet>
    </>
  );
};

PortfolioTransactionFilter.displayName = 'TransactionFilter';
